import lodash from 'lodash';
import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { GET_LEAD_PAYMENT_APPROVAL_DRIVERS_CATALOG, SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA } from '../../constants';
import { USER_GROUP_TRANSPORT } from '../../../../../common/constants';
import { getUsers as getUsersReq } from '../../../../../common/requests/users';

function* getDriversCatalog() {
    const store = yield select();
    const { dataModel, catalogs: { drivers } } = store.Leads.LeadPaymentApproval.approvalDetails;
    const driverField = dataModel.schema.tree.bought_info.type.tree.bought_by_driver;

    driverField.isLoading = false;
    driverField.externalData = [];

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
        payload: {
            dataModel,
            $lastUpdateTime: Date.now(),
        },
    });

    const params = {
        searchByName: drivers.filters.searchByName,
        groups: [USER_GROUP_TRANSPORT],
    };

    const usersRes = yield call(getUsersReq, params);

    driverField.isLoading = false;
    driverField.externalData = usersRes.options;

    yield put({
        type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
        payload: {
            dataModel,
            $lastUpdateTime: Date.now(),
        },
    });
}

export default function* getDriversCatalogSaga() {
    yield takeEvery(GET_LEAD_PAYMENT_APPROVAL_DRIVERS_CATALOG, getDriversCatalog);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/redux/sagas/getDriversCatalog.saga.js